import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import API_ROOT from '../../../../../utils/api';
import axios from '../../../../../utils/secured-axios';
import Button, { ButtonSize } from '../../../../common/buttons/Button';
import css from './PurchaseVerifyUserAlert.module.scss';

interface ElementProps {
  className?: string;
  labelType: string;
}

interface State {
  submitted: boolean;
}

type Props = ElementProps & InjectedIntlProps;

class PurchaseVerifyUserAlert extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      submitted: false,
    };
  }
  private async handleSubmit() {
    try {
      await axios.get(`${API_ROOT}/users/send_verification`);
      this.setState({ submitted: true });
    } catch (e) {
      // error
    }
  }
  public render() {
    const { className, labelType, intl } = this.props;
    const { submitted } = this.state;
    const classes = classNames(css.PurchaseVerifyUserAlert, className);

    return (
      <div className={classes}>
        <div className={css.PurchaseVerifyUserAlert__Title}>
          {intl.formatMessage({
            id: 'purchases.purchaseVerifyUserAlert.title',
          })}
        </div>
        <div className={css.PurchaseVerifyUserAlert__Description}>
          {intl.formatMessage({
            id: `purchases.purchaseVerifyUserAlert.description.${labelType}`,
          })}
        </div>
        <Button
          isFull={true}
          disabled={submitted}
          buttonSize={ButtonSize.Medium}
          onClick={this.handleSubmit}
        >
          {intl.formatMessage({
            id: `purchases.purchaseVerifyUserAlert.submitButton.${
              submitted ? 'submitted' : 'submit'
            }`,
          })}
        </Button>
      </div>
    );
  }
}

export default injectIntl(PurchaseVerifyUserAlert);
